import { useState } from 'react'
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  HStack,
  useTheme
} from '@chakra-ui/react'

interface ISignOffConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (credentials: { username: string; password: string }) => void
}

const SignOffConfirmationModal = ({ isOpen, onClose, onConfirm }: ISignOffConfirmationModalProps) => {
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const { currentTheme } = useTheme()
  const primaryColor = currentTheme?.primaryColor || '#3182CE'

  const handleConfirm = () => {
    onConfirm({ username, password })
    setUsername('')
    setPassword('')
  }

  const handleClose = () => {
    setUsername('')
    setPassword('')
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="12px">
        <ModalHeader fontWeight={600} color="gray.800">
          Sign off confirmation
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text color="gray.700" fontSize="md" marginBottom={4}>
            Please confirm this action by providing your username and password
          </Text>
          <VStack align="stretch" spacing={4}>
            <FormControl>
              <FormLabel fontSize="md" color="gray.700">
                Supervisor username
              </FormLabel>
              <Input
                value={username}
                onChange={event => setUsername(event.target.value)}
                placeholder="Enter username"
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="md" color="gray.700">
                Password
              </FormLabel>
              <Input
                value={password}
                onChange={event => setPassword(event.target.value)}
                placeholder="Enter password"
                type="password"
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack spacing={3}>
            <Button variant="outline" border={'none'} onClick={handleClose}>
              Cancel
            </Button>
            <Button backgroundColor={primaryColor} color="white" fontWeight={500} lineHeight={6} border="none" borderRadius="6px" paddingY={2} paddingX={6} onClick={handleConfirm} _hover={{ opacity: 0.8 }}>
              Sign off
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default SignOffConfirmationModal

